/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Search_Placeholder_VideoInputs */

const vi_media_search_placeholder_video = /** @type {(inputs: Media_Search_Placeholder_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm video theo tên file, mô tả…`)
};

/**

* @param {Media_Search_Placeholder_VideoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_search_placeholder_video = /** @type {((inputs?: Media_Search_Placeholder_VideoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Search_Placeholder_VideoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_search_placeholder_video(inputs)
});